import React from "react";
import { useTranslation } from "react-i18next";

const EnergyContactInfoSection = () => {
  const { t } = useTranslation();

  return (
    <section className="info-ene-section">
      <div className="description-container">
        <hr style={{ width: "50%" }} />
        <h1
          className="clients-title"
          style={{
            marginBottom: "1rem",
            marginTop: "1rem",
            fontSize: "1.8rem",
          }}
        >
          {t("energy_page.contact_section.title")}
        </h1>
        <p className="desc-txt">
          {t("energy_page.contact_section.info_1")}{" "}
          <strong>comercialsuntacc@otacc.com</strong>.
        </p>
        <b
          className="desc-txt"
          style={{
            fontSize: "1.5rem",
            color: "black",
            marginTop: "1rem",
            textAlign: "center",
          }}
        >
          {t("energy_page.contact_section.info_2")}{" "}
        </b>
      </div>
    </section>
  );
};

export default EnergyContactInfoSection;
